export enum DashboardStep {
  NewInquiry = 'New Inquiry',
  AcceptOffer = 'Accept Offer',
  AcceptPosAutomatedOffer = 'Accept Pos Automated Offer',
  AcceptHilAutomatedOffer = 'Accept Hil Automated Offer',
  FAQ = 'FAQ',
  NoActiveApplication = 'No Active Application',
  AccountSettings = 'AccountSettings',
  LoanDetails = 'LoanDetails',
  NotFoundContact = 'NotFoundContact',
  BorrowerInformation = 'BorrowerInformation',
  CoBorrowerInformation = 'CoBorrowerInformation',
  FundingInformation = 'FundingInformation',
  HomeOwnership = 'HomeOwnership',
  ContractorWorkOrder = 'ContractorWorkOrder',
  AdditionalInformation = 'AdditionalInformation',
}
